<template>
  <section class="single">
    <ModuleSection :id="`_${$options.name}`">
      <div class="single__option">
        <FormInput
          type="radio"
          name="shippingOption"
          value="1"
          @change="selectionData.option = 1"
          :checked="selectionData.option == 1"
        >
          Sofort
        </FormInput>
      </div>

      <div class="single__option">
        <FormInput
          type="radio"
          name="shippingOption"
          value="2"
          @change="selectionData.option = 2"
          :checked="selectionData.option == 2"
        >
          Lieferung verzögern
          <!-- <small>Sie diese Option, wenn Sie möchten, dass wir die Box zu einem bestimmten Termin versenden.</small> -->

          <div v-if="selectionData.option == 2" class="u-mt-2">
            <FormLabel for="desiredShippingDate">Bitte wählen Sie ein Datum:</FormLabel>

            <FormInput
              class="shipping__input-date"
              type="date"
              id="desiredShippingDate"
              name="desiredShipppingDate"
              placeholder="i.e: 01.12"
              v-model="selectionData.desiredShippingDate"
              :min="new Date(+new Date().setHours(0, 0, 0, 0) + 3 * 86400000).toLocaleDateString('fr-CA')"
              :max="new Date(+new Date().setHours(0, 0, 0,0)+ (730 * 86400000)).toLocaleDateString('fr-CA')"
              :required="true"
            />
          </div>
        </FormInput>
      </div>

      <Notice v-if="selectionData.option == 2">
        <p>Wir verzögern den Versand Ihrer Bestellung und übergeben diese erst ein paar Werktage vor dem gewählten Termin an DPD. Der Versandkarton erhält zusätzlich einen Aufkleber, dass das Paket an dem gewählten Datum zu öffnen ist.</p>
      </Notice>

      <hr>

      <p>Lieferland auswählen:</p>

      <div class="shipping__option-duplex">
        <div class="shipping__option">
          <FormInput
            type="radio"
            name="shippingInternational"
            value="de"
            @change="val => selectionData.region = val"
            :checked="selectionData.region == 'de'"
          >
            <div class="shipping__icon --has-left-gap">
              <img src="@/assets/images/landing-page/flags/de.svg" alt="Deutschland Flag">
            </div>

            <div class="shipping__label">
              Deutschland
            </div>
          </FormInput>
        </div>

        <Price class="shipping__price">
          <template v-slot:brutto>{{ splittedTaxSingle(5.9) }}</template>
          <template v-slot:netto>5,90 €</template>
        </Price>
      </div>

      <div class="shipping__option-duplex">
        <div class="shipping__option">
          <FormInput
            type="radio"
            name="shippingInternational"
            value="eu"
            @change="val => selectionData.region = val"
            :checked="selectionData.region == 'eu'"
          >
            <div class="shipping__icon --has-left-gap">
              <img src="@/assets/images/landing-page/flags/eu.svg" alt="Europe Flag">
            </div>

            <div class="shipping__label">
              Europa
            </div>
          </FormInput>
        </div>

        <Price class="shipping__price">
          <template v-slot:brutto>{{ splittedTaxSingle(13.5) }}</template>
          <template v-slot:netto>13,50 €</template>
        </Price>
      </div>

      <div class="shipping__option-duplex">
        <div class="shipping__option">
          <FormInput
            type="radio"
            name="shippingInternational"
            value="ch_uk"
            @change="val => selectionData.region = val"
            :checked="selectionData.region == 'ch_uk'"
          >
            <div class="shipping__icon --has-left-gap">
              <img src="@/assets/images/landing-page/flags/ch.svg" alt="Switzerland Flag">
              <img src="@/assets/images/landing-page/flags/uk.svg" alt="United Kingdom Flag">
            </div>

            <div class="shipping__label">
              Schweiz / UK
            </div>
          </FormInput>
        </div>

        <Price class="shipping__price">
          <template v-slot:brutto>{{ splittedTaxSingle(35.0) }}</template>
          <template v-slot:netto>35,00 €</template>
        </Price>
      </div>

      <div class="shipping__option-duplex">
        <div class="shipping__option">
          <FormInput
            type="radio"
            name="shippingInternational"
            value="other"
            @change="val => selectionData.region = val"
            :checked="selectionData.region == 'other'"
          >
            <div class="shipping__icon --has-left-gap">
              <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#B7ECEC"/><path d="M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31Z" stroke="#63A3A3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.66659 27.7333L7.99992 21H9.43992C9.74402 21.001 10.0443 20.9318 10.3172 20.7976C10.5901 20.6635 10.8283 20.4681 11.0133 20.2267C11.2037 19.9908 11.3357 19.7132 11.3982 19.4166C11.4608 19.1199 11.4522 18.8127 11.3733 18.52L10.3733 14.52C10.2685 14.0864 10.0208 13.7006 9.67005 13.4249C9.31935 13.1492 8.88604 12.9995 8.43992 13H1.33325" stroke="#63A3A3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M27.9999 7H22.5599C22.1137 6.9995 21.6804 7.14916 21.3297 7.42489C20.979 7.70062 20.7313 8.08636 20.6265 8.52L19.6265 12.52C19.5493 12.8137 19.5429 13.1216 19.6078 13.4183C19.6727 13.7149 19.8071 13.992 19.9999 14.2267C20.1848 14.4681 20.423 14.6635 20.6959 14.7976C20.9688 14.9318 21.2691 15.001 21.5732 15H23.6799L24.7199 21.3333C24.7979 21.7951 25.0354 22.2148 25.3912 22.5194C25.7469 22.824 26.1982 22.9941 26.6665 23H29.3332" stroke="#63A3A3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>

            <div class="shipping__label">
              Andere Länder<br/>
              <span class="shipping__additional_info" v-if="selectionData.region=='other'">Lieferungen in die Türkei und nach Paraguay können aktuell nicht durchgeführt werden.</span>
            </div>
          </FormInput>
        </div>

        <Price class="shipping__price">
          <template v-slot:brutto>{{ splittedTaxSingle(45.0) }}</template>
          <template v-slot:netto>45,00 €</template>
        </Price>
      </div>
    </ModuleSection>
  </section>
</template>

<script>
import { logicMixin } from '@/mixins/LogicMixin';
import ModuleSection from '@/components/Composer/ModuleSection';
import Price from '@/components/Common/Price';
import FormLabel from '@/components/Common/FormLabel.vue';
import FormInput from '@/components/Common/FormInput';
import Notice from '@/components/Composer/Notice';

export default {
  name: 'ModuleShippingSingle',
  props: ['selectionData'],
  mixins: [logicMixin],
  components: {
    ModuleSection,
    Price,
    FormLabel,
    FormInput,
    Notice
  },
  computed: {
    displayDate: function() {
      const d = new Date();
      const day = d.getDay();
      var display = '';
      switch (day) {
        case 0: display = 'Sonntag'; break;
        case 1: display = 'Montag'; break;
        case 2: display = 'Dienstag'; break;
        case 3: display = 'Mittwoch'; break;
        case 4: display = 'Donnerstag'; break;
        case 5: display = 'Freitag'; break;
        case 6: display = 'Samstag'; break;
      }
      return `${display} ${('0' + d.getDate()).slice(-2)}.${('0' + (d.getMonth() + 1)).slice(-2)}`;
    }
  }
};
</script>

<style lang="scss" scoped>
/**
 * Shipping Single
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Shipping options for single delivery
 * @since 2021-08-31
**/

$component: 'single';

.#{$component} {
  @include margin-top(- map-get($spacers, 2));

  &__option {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    @include margin-bottom($spacer);

    ::v-deep {
      .form-input {
        flex-grow: 1;
      }

      .price {
        flex-shrink: 0;
        @include margin-left(map-get($spacers, 2));
      }
    }
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
  }
}
</style>
